module.exports = __webpack_public_path__ + "img/mb.8c098638.png";